import dayjs from 'dayjs';

export const FORMAT_AMERICAN = 'YYYY-MM-DD';
export const FORMAT_AMERICAN_TIME = `${FORMAT_AMERICAN} HH:mm:ss`;
export const FORMAT_BRAZIL = 'DD/MM/YYYY';
export const FORMAT_BRAZIL_TIME = `${FORMAT_BRAZIL} HH:mm:ss`;
export const FORMAT_TIME = 'HH:mm';

export const format = (date, template) => dayjs(date).format(template);

export const addDays = (date, days) => dayjs(date).add(days, 'day');

export const greaterThan = (current, compare) => dayjs(current).isAfter(compare);

export const lessThan = (current, compare) => dayjs(current).isBefore(compare);

export function dateToAmericanFormat(date, defaultValue = null) {
  const dateOrDefault = date ?? defaultValue;
  if (!dateOrDefault) return null;

  return format(dateOrDefault, FORMAT_AMERICAN);
}

export function dateTimeToBrazilFormat(date, defaultValue = null) {
  const dateOrDefault = date ?? defaultValue;
  if (!dateOrDefault) return null;

  return format(dateOrDefault, FORMAT_BRAZIL_TIME);
}

export function dateWithCurrentYear(day, month) {
  const date = new Date();
  date.setDate(day);
  date.setMonth(month - 1);
  return date;
}

export function diffDays(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  return ((end - start) / (1000 * 3600 * 24));
}

export function inInterval(current, start, end) {
  if (dayjs(current).isBefore(start)) return false;
  if (dayjs(current).isAfter(end)) return false;
  return true;
}

export const formatTime = (time) => {
  if (time === '--:--') return '00:00';
  let h = Math.floor(time / 60);
  let m = time % 60;
  h = h < 10 ? `0${h}` : h;
  m = m < 10 ? `0${m}` : m;
  return `${h}:${m}`;
};

export const convertToSeconds = (time) => {
  const hour = time.split(':');
  const seconds = (+hour[0]) * 60 * 60 + (+hour[1]);

  return seconds;
};

export const convertDatePtBr = (date, formatter = FORMAT_AMERICAN) => {
  if (date) {
    const dateParts = date.split('/');

    return format(new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]).toString(), formatter);
  }

  return date;
};

export function dataFormatadaBr(date) {
  const data = new Date(date);
  const dia = data.getDate().toString();
  const diaF = (dia.length === 1) ? `0${dia}` : dia;
  const mes = (data.getMonth() + 1).toString();
  const mesF = (mes.length === 1) ? `0${mes}` : mes;
  const anoF = data.getFullYear();

  return `${diaF}/${mesF}/${anoF}`;
}

export const convertDateUTC3 = (value) => {
  if (!value) return '';
  const data = new Date(value);
  data.setHours(data.getHours() + 3);
  const dateString = data.toLocaleString('pt-BR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return dateString.replace(',', '');
};

export default function formatDataToView(date) {
  let dateCt = date;
  if (typeof dateCt === 'string') dateCt = new Date(dateCt);

  return dateCt.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).replace(',', '');
}

export function formatDataSt(date) {
  let dateCt = date;
  if (typeof dateCt === 'string') dateCt = new Date(dateCt);
  return dateCt;
}
